import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Force this session to re-verify 2FA before any data access
      try {
        const t = await auth.currentUser.getIdToken();
        await fetch('https://europe-west1-dbos-core-prod.cloudfunctions.net/twofa', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${t}` },
          body: JSON.stringify({ action: 'reset' }),
        });
      } catch (resetErr) {
        console.warn('2FA reset failed:', resetErr);
      }
    } catch (err) {
      setError('Invalid email or password. Please try again.');
      setLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (err) {
      setError('Could not send reset email. Check the address and try again.');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <img src="/android-chrome-192x192.png" alt="DBOS" className="logo-d-img" />
          <span className="logo-bos">DBOS</span>
        </div>
        <h1 className="login-title">SmartClient Portal</h1>

        {!resetMode ? (
          <>
            <p className="login-subtitle">Sign in to access your dashboard</p>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleLogin} className="login-form">
              <div className="input-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  disabled={loading}
                  autoComplete="email"
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Your password"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
              </div>
              <button type="submit" disabled={loading} className="login-button">
                {loading ? (
                  <span className="loading-spinner-small"></span>
                ) : 'Sign In →'}
              </button>
            </form>
            <div className="login-footer">
              <p>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => { setResetMode(true); setError(''); setResetSent(false); }}
                >
                  Forgot password?
                </button>
              </p>
              <p className="create-account-line">New to DBOS? <a href="https://login.dbos.world/register" className="create-account-link">Create account</a></p>
              <p className="version-tag">V1.0.0</p>
            </div>
          </>
        ) : (
          <>
            <p className="login-subtitle">Reset your password</p>
            {error && <div className="error-message">{error}</div>}
            {resetSent ? (
              <div className="reset-sent-message">
                ✓ If an account exists for that email, a reset link is on its way. Check your inbox.
              </div>
            ) : (
              <form onSubmit={handlePasswordReset} className="login-form">
                <div className="input-group">
                  <label htmlFor="reset-email">Email Address</label>
                  <input
                    id="reset-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    disabled={loading}
                    autoComplete="email"
                  />
                </div>
                <button type="submit" disabled={loading} className="login-button">
                  {loading ? (
                    <span className="loading-spinner-small"></span>
                  ) : 'Send reset link'}
                </button>
              </form>
            )}
            <div className="login-footer">
              <p>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => { setResetMode(false); setError(''); setResetSent(false); }}
                >
                  ← Back to sign in
                </button>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default Login;
